/* eslint-disable no-restricted-imports */
/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import React from 'react'
import type { ErrorBoundaryProps } from 'react-error-boundary'

import { logger } from '../../../logger'

const onRenderError: ErrorBoundaryProps['onError'] = (error, info) => {
  logger.error('render error for AddressPoliciesAndFees lazy loadable section', info, error)
}

const onLoadingError = (error: unknown) => {
  logger.error('loading error for AddressPoliciesAndFees lazy loadable section', error)
}

const loadFn = /* #__LOADABLE__ */ async () =>
  await import(/* webpackChunkName: "AddressPoliciesAndFees" */ './AddressPoliciesAndFees')

const handleReload = async () => await AddressPoliciesAndFeesLazyLoadable.reload()

const options = {
  errorFallback: () => (
    <ErrorFallback
      message="Sorry, we couldn't load the policies and fees..."
      onClickReload={handleReload}
    />
  ),

  loadingFallback: () => {
    return <LoadingFallback height={73} name="Policies and fees" />
  },
  onRenderError,
  onLoadingError,
}

export const AddressPoliciesAndFeesLazyLoadable = createLazyLoadableSection(loadFn, options)
